import { Check, ArrowRight } from "lucide-react";

const procedures = [
  { title: "Laparoscopic Surgery", desc: "Minimally invasive keyhole surgery for hernia, gallbladder, and appendix. 3-4 small incisions instead of one large cut.", benefits: ["Same-day discharge", "Minimal scarring", "Faster recovery", "Less pain"] },
  { title: "Laser Procedures", desc: "State-of-the-art laser for piles, fissures, and fistulas. Virtually painless with no cuts or stitches.", benefits: ["Pain-free treatment", "No stitches needed", "2-3 day recovery", "High success rate"] },
  { title: "Endoscopy & Colonoscopy", desc: "Advanced diagnostic and therapeutic procedures for gastrointestinal conditions using HD imaging.", benefits: ["Accurate diagnosis", "Biopsy during procedure", "Quick procedure", "Minimal discomfort"] },
];

export default function FeaturedProcedures({ onBookAppointment }) {
  return (
    <section data-testid="featured-procedures" className="py-16 md:py-24 bg-clinical">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">Featured Procedures</p>
          <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">Advanced Surgical Techniques</h2>
          <p className="reveal delay-2 text-base md:text-lg text-slate-500 mt-3 max-w-2xl mx-auto">Combining cutting-edge technology with years of expertise for the best surgical outcomes.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {procedures.map((proc, i) => (
            <div key={proc.title} data-testid={`procedure-card-${i}`} className={`reveal delay-${i + 1} bg-white rounded-xl shadow-sm border border-slate-100 p-6 md:p-8 hover:shadow-md transition-all duration-300`}>
              <h3 className="font-heading font-bold text-navy text-xl mb-3">{proc.title}</h3>
              <p className="text-slate-600 text-base leading-relaxed mb-5">{proc.desc}</p>
              <ul className="space-y-2.5 mb-6">
                {proc.benefits.map(b => (<li key={b} className="flex items-center gap-2 text-sm text-slate-600"><Check className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={2} />{b}</li>))}
              </ul>
              <button onClick={onBookAppointment} className="inline-flex items-center gap-1.5 text-teal font-medium text-sm hover:gap-2.5 transition-all">Book Consultation <ArrowRight className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
